import React from 'react'

import {
  array, bool,
} from 'prop-types'

import EmptyFeed from './Components/EmptyFeed/EmptyFeed'
import Feed from './Components/Feed/Feed'
import MaintenanceFeed from './Components/MaintenanceFeed/MaintenanceFeed'

function NotificationsWidget({ notifications, isMaintenance = false }) {
  if (notifications.length > 0) {
    return (
      <span>
        <Feed notifications={notifications} />
      </span>
    )
  }

  return (
    <span>
      {isMaintenance ? <MaintenanceFeed /> : <EmptyFeed />}
    </span>
  )
}

NotificationsWidget.propTypes = {
  notifications: array.isRequired,
  isMaintenance: bool,
}

export default NotificationsWidget
